var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('nav-header'),_c('v-container',[(_vm.showView)?_c('router-view',{key:_vm.$route.path}):_vm._e(),_c('loader')],1)],1),_c('nav-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }